// extracted by mini-css-extract-plugin
export default {"textApply":"cu9ho","textTotalCount":"pWRim","footerAdditional":"Wm07e","reset":"t0_z1"};